"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DATA_SNACKBAR_TEXT = exports.DATA_SNACKBAR_CLOSE = exports.DATA_SNACKBAR_ITEM = void 0;
exports.DATA_SNACKBAR_ITEM = 'data-snackbar-item';
exports.DATA_SNACKBAR_CLOSE = 'data-snackbar-close';
exports.DATA_SNACKBAR_TEXT = 'data-snackbar-text';
